import * as React from "react";

export const BOOK_WITH_QUESTION_MARK_SVG = (
  <svg width="103" height="88" viewBox="0 0 103 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M93.2621 3.67211L86.1732 4.20512C81.0063 4.59363 75.9893 4.30091 71.2618 3.33528C68.5157 2.77422 65.7073 2.59617 62.9139 2.8062C57.8552 3.18657 53.0863 4.78557 48.7251 7.55581C45.7649 6.25008 42.6768 5.41484 39.5332 5.07302C38.758 4.98934 38.0608 5.54907 37.9764 6.32446C37.8919 7.09984 38.4522 7.79704 39.2278 7.88126C42.052 8.18843 44.8303 8.93452 47.4988 10.1012L51.4142 62.175C49.9621 62.5674 48.6946 63.3804 47.7386 64.4677C44.6676 63.7334 41.5303 63.4789 38.3989 63.7144C35.6059 63.9244 32.8557 64.5204 30.2242 65.4856C25.6945 67.1475 20.7777 68.1871 15.6105 68.5756L8.5213 69.1087C8.26234 69.1282 8.03598 68.9335 8.01651 68.6745L7.59457 63.0629C7.53607 62.2849 6.85801 61.7019 6.08021 61.7603C5.3024 61.8188 4.71915 62.4967 4.77765 63.2747L5.42605 71.8982C5.60124 74.2281 7.63929 75.9811 9.96915 75.8059L47.7603 72.9644C48.5924 72.9327 49.3543 71.9551 48.9834 71.0632C48.8291 70.6482 48.7341 70.2157 48.7012 69.7774C48.5074 67.2 50.4466 64.9455 53.024 64.7517C55.6014 64.5579 57.856 66.4969 58.0498 69.0745C58.0827 69.513 58.0535 69.9548 57.9629 70.3878C57.7872 71.1759 58.4152 72.1661 59.4513 72.0853L71.6251 71.17L72.1041 77.5399C72.3201 80.4135 74.8338 82.5756 77.7074 82.3596C80.581 82.1435 82.7431 79.63 82.527 76.7562L82.0481 70.3863L97.248 69.2434C99.578 69.0682 101.331 67.0302 101.156 64.7003L96.7954 6.71143C96.6594 4.89928 95.0742 3.53585 93.2621 3.67211V3.67211ZM9.75734 72.989C9.06293 73.0412 8.44754 72.579 8.28313 71.9254C8.43141 71.9344 15.822 71.3928 15.822 71.3928C21.2494 70.9847 26.4221 69.8895 31.1968 68.138C33.5833 67.2624 36.0777 66.7221 38.6104 66.5317C41.1695 66.3393 43.7339 66.5073 46.2554 67.0301C45.9426 67.9551 45.8064 68.956 45.8841 69.9894C45.8911 70.0833 45.8999 70.177 45.9105 70.2708L9.75736 72.9892L9.75734 72.989ZM54.231 61.9636L50.3156 9.89112C54.2606 7.40208 58.5657 5.96618 63.1258 5.62331C65.6587 5.43286 68.2058 5.59427 70.6962 6.10311C75.6793 7.12115 80.9576 7.43014 86.3849 7.02206L93.4737 6.48905C93.7325 6.46959 93.959 6.66428 93.9785 6.92323L98.1122 61.9002C98.1317 62.1591 97.9368 62.3855 97.6781 62.405L90.5892 62.938C88.8967 63.0652 87.2126 63.1166 85.5496 63.0977C89.226 59.9528 91.4128 55.1614 91.0231 49.9781C90.9312 48.7568 90.6986 47.551 90.3315 46.394C90.0956 45.6504 89.3013 45.2393 88.558 45.4748C87.8145 45.7106 87.4029 46.5046 87.6388 47.2482C87.9397 48.1969 88.1307 49.1867 88.2062 50.19C88.7387 57.2726 83.4099 63.4682 76.3272 64.0007C69.2445 64.5333 63.0491 59.2044 62.5165 52.1216C61.984 45.0391 67.3129 38.8435 74.3955 38.311C78.2161 38.0237 81.9394 39.4375 84.6106 42.19C85.1538 42.7499 86.048 42.763 86.6081 42.22C87.1678 41.6766 87.1812 40.7824 86.638 40.2227C83.3816 36.8672 78.8423 35.1436 74.1839 35.4938C65.5479 36.1432 59.0504 43.6971 59.6998 52.3332C59.9823 56.0909 61.5732 59.4429 63.9906 61.9783C62.0187 62.3506 60.0852 62.9203 58.2083 63.6804C57.1003 62.7488 55.7255 62.1342 54.231 61.9636ZM60.8828 69.1448C60.8793 69.0507 60.874 68.9567 60.8669 68.8627C60.7892 67.8293 60.5048 66.86 60.0573 65.9922C62.2838 65.168 64.5916 64.6374 66.9436 64.4087C68.266 65.2509 69.72 65.8965 71.2604 66.3148L71.4137 68.353L60.8828 69.1448ZM77.4958 79.5424C76.1755 79.6417 75.0206 78.6483 74.9214 77.3281L74.1309 66.8148C74.9207 66.8764 75.7251 66.8791 76.539 66.8179C77.3531 66.7566 78.1479 66.6339 78.9196 66.4548L79.7101 76.968C79.8095 78.2882 78.8162 79.4432 77.4958 79.5424ZM97.0363 66.4265L81.8364 67.5693L81.7 65.7544C84.6603 65.985 87.7201 65.9867 90.801 65.7551C90.801 65.7551 98.1897 65.1854 98.3347 65.1544C98.2699 65.8251 97.7308 66.3742 97.0363 66.4265V66.4265Z"
      fill="#7B828D"
    />
    <path
      d="M80.4485 48.1387C80.2954 45.9371 78.5021 44.1626 76.2776 44.0108C75.0158 43.9258 73.8139 44.3458 72.8928 45.1967C71.9845 46.0357 71.4636 47.2218 71.4636 48.4513C71.4636 49.1602 72.0445 49.7352 72.761 49.7352C73.4775 49.7352 74.0583 49.1603 74.0583 48.4514C74.0583 47.9235 74.2731 47.4343 74.6633 47.0739C75.0529 46.7139 75.5622 46.5364 76.0993 46.5726C77.0384 46.6366 77.7955 47.3859 77.8601 48.3153C77.9256 49.2549 77.3032 50.0853 76.3804 50.2897C75.3699 50.513 74.6642 51.3825 74.6643 52.4035L74.6643 54.716C74.6644 55.425 75.2452 55.9999 75.9617 56C76.6782 56 77.259 55.4251 77.259 54.7161L77.2589 52.715C79.269 52.1216 80.5955 50.2463 80.4485 48.1387Z"
      fill="#7B828D"
    />
    <path
      d="M77.0849 57.8068C76.8396 57.5614 76.4994 57.4215 76.1526 57.4215C75.8058 57.4215 75.4656 57.5615 75.2203 57.8067C74.9751 58.0534 74.834 58.3924 74.834 58.7407C74.834 59.0877 74.9751 59.4281 75.2204 59.6734C75.4657 59.9188 75.8059 60.06 76.1527 60.06C76.4995 60.06 76.8397 59.919 77.085 59.6735C77.3302 59.428 77.4713 59.0878 77.4713 58.7408C77.4713 58.3925 77.3302 58.0535 77.0849 57.8068Z"
      fill="#7B828D"
    />
    <path
      d="M5.80947 58.1596C6.58727 58.1011 7.17052 57.4232 7.11202 56.6453L3.88277 13.6976C3.8633 13.4386 4.05819 13.2122 4.31696 13.1928L11.4058 12.6598C16.8331 12.2517 22.0058 11.1567 26.7807 9.40512C28.794 8.66652 30.8908 8.16458 33.0132 7.91287C33.7877 7.82097 34.3413 7.11861 34.2496 6.34387C34.1577 5.56933 33.4578 5.01368 32.6806 5.10747C30.34 5.385 28.0277 5.93868 25.8079 6.75297C21.278 8.41467 16.3612 9.45431 11.1942 9.84282L4.10515 10.3758C2.29302 10.5121 0.929593 12.0972 1.06585 13.9094L4.2951 56.8571C4.3536 57.635 5.03166 58.2181 5.80947 58.1596V58.1596Z"
      fill="#7B828D"
    />
  </svg>
);

export const SCHOOL_HAT = (
  <svg width="96" height="58" viewBox="0 0 96 58" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M94.798 17.3609L46.7881 0.0843196C46.4076 -0.0530804 45.9876 -0.0214797 45.6319 0.17122L27.4336 10.0074C26.7441 10.3802 26.4871 11.2412 26.86 11.9315C27.2329 12.6218 28.0946 12.8787 28.7849 12.5058L46.4235 2.97182L63.695 9.18692L64.4792 19.6178C55.3674 17.0418 47.8826 17.357 47.546 17.3728C47.5196 17.3741 47.4933 17.376 47.4671 17.3787C47.1077 17.4153 38.5649 18.3419 29.1651 23.0318C25.4151 24.9017 22.0288 27.1335 19.1004 29.6644C18.8811 29.8542 18.7295 30.1036 18.6575 30.3764L4.88934 25.4211L22.9352 15.6669C23.6255 15.2941 23.8825 14.433 23.5089 13.7428C23.136 13.0525 22.2742 12.7956 21.5847 13.1684L0.744532 24.4328C0.251872 24.699 -0.0379385 25.2305 0.00401153 25.7885C0.0460215 26.3472 0.412011 26.8287 0.938931 27.0182L18.8085 33.4498L19.3184 40.2311C19.3772 41.0134 20.0595 41.5996 20.841 41.5408C21.6232 41.482 22.2095 40.8004 22.1507 40.0182L21.574 32.3488L21.5738 32.3458L21.4992 31.3533C24.1228 29.1656 27.1247 27.2226 30.4328 25.5732C39.0356 21.2812 47.0903 20.2811 47.7201 20.208C48.3406 20.1856 55.9181 19.9787 64.7067 22.6436L65.7648 36.716C63.7403 37.4838 62.3685 39.5171 62.539 41.7842C62.6956 43.8671 64.1096 45.5603 65.9811 46.1753L65.1867 48.8564C58.8082 50.4547 53.8065 52.3702 50.3026 54.5624C41.568 50.78 27.4032 50.5905 22.9494 50.6309L22.6507 46.6585C22.5919 45.8763 21.9096 45.2901 21.1281 45.3488C20.3459 45.4076 19.7596 46.0893 19.8184 46.8715L20.2177 52.1819C20.2746 52.9392 20.9182 53.5181 21.6781 53.4947C21.8635 53.4889 40.3331 52.9646 49.8161 57.4598C50.0423 57.5669 50.2887 57.6108 50.5312 57.5926C50.7729 57.5744 51.01 57.4942 51.2183 57.3536C54.1445 55.3811 58.6177 53.5582 64.2446 52.0349L63.5735 54.302C63.4404 54.7498 63.5362 55.2339 63.8294 55.5975C64.1226 55.9603 64.5759 56.1568 65.0411 56.1219L72.2161 55.5824C72.682 55.5473 73.1001 55.2853 73.3357 54.8827C73.5713 54.4794 73.5938 53.9863 73.396 53.5634L71.8624 50.2906C75.6825 49.5597 78.4148 49.2294 78.4461 49.2256C79.201 49.1358 79.7516 48.4671 79.6946 47.709L79.2953 42.3986C79.2365 41.6172 78.5541 41.0302 77.7726 41.089C76.9904 41.1478 76.4043 41.8301 76.4631 42.6116L76.7618 46.5862C75.4466 46.7747 73.2629 47.1159 70.6192 47.6386L69.7993 45.8882C71.557 45.0003 72.7028 43.1147 72.5462 41.0317C72.3757 38.764 70.7152 36.9593 68.5979 36.503L67.6301 23.6306C70.3818 24.651 72.9581 25.8799 75.3122 27.307L75.3868 28.2996L75.3871 28.3025L75.9637 35.972C76.0226 36.7542 76.7043 37.3404 77.4865 37.2816C78.2687 37.2228 78.855 36.5412 78.7961 35.759L78.2862 28.9777L94.993 19.9462C95.4857 19.68 95.7756 19.1493 95.7336 18.5905C95.6917 18.0325 95.3249 17.5504 94.798 17.3609ZM66.8804 53.1352L68.1114 48.9817L69.9494 52.9045L66.8804 53.1352ZM69.7132 41.2447C69.8032 42.4418 68.9028 43.4885 67.705 43.5786C66.508 43.6686 65.4612 42.7682 65.3712 41.5712C65.2811 40.3734 66.1815 39.3267 67.3785 39.2366C68.5763 39.1466 69.6232 40.0469 69.7132 41.2447ZM77.9753 25.9162C77.8633 25.6573 77.6759 25.4334 77.4307 25.2785C74.4082 23.3721 71.0341 21.7808 67.3964 20.5332L66.6224 10.2403L90.8475 18.9579L77.9753 25.9162Z"
      fill="#7B828D"
    />
  </svg>
);

export const CERTIFICATE_SVG = (
  <svg width="37" height="33" viewBox="0 0 37 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M36.4286 0.5H1.00002C0.684446 0.5 0.428589 0.755857 0.428589 1.07143V26.2143C0.428589 26.5298 0.684446 26.7857 1.00002 26.7857H36.4286C36.7441 26.7857 37 26.5298 37 26.2143V1.07143C37 0.755786 36.7441 0.5 36.4286 0.5Z"
        fill="#8B7C77"
      />
      <path
        d="M3.28573 24.5C2.97017 24.5 2.7143 24.2441 2.7143 23.9286V0.5H1.00002C0.684446 0.5 0.428589 0.755857 0.428589 1.07143V26.2143C0.428589 26.5298 0.684446 26.7857 1.00002 26.7857H36.4286C36.7441 26.7857 37 26.5298 37 26.2143V24.5H3.28573Z"
        fill="#7D6D68"
      />
      <path
        d="M34.143 5.64279C32.8825 5.64279 31.8573 4.61743 31.8573 3.35707C31.8573 3.0415 31.6014 2.78564 31.2858 2.78564H6.14293C5.82736 2.78564 5.5715 3.0415 5.5715 3.35707C5.5715 4.61743 4.54614 5.64279 3.28578 5.64279C2.97022 5.64279 2.71436 5.89864 2.71436 6.21422V21.0714C2.71436 21.3869 2.97022 21.6428 3.28578 21.6428C4.54614 21.6428 5.5715 22.6681 5.5715 23.9285C5.5715 24.2441 5.82736 24.5 6.14293 24.5H31.2858C31.6014 24.5 31.8573 24.2441 31.8573 23.9285C31.8573 22.6681 32.8825 21.6428 34.143 21.6428C34.4585 21.6428 34.7144 21.3869 34.7144 21.0714V6.21422C34.7144 5.89857 34.4585 5.64279 34.143 5.64279Z"
        fill="white"
      />
      <path
        opacity="0.2"
        d="M7.85721 22.7858C7.54165 22.7858 7.28578 22.5299 7.28578 22.2144C7.28578 20.954 6.26042 19.9287 5.00007 19.9287C4.6845 19.9287 4.42864 19.6728 4.42864 19.3572V5.33545C4.09214 5.53059 3.702 5.64296 3.28578 5.64296C2.97022 5.64296 2.71436 5.89881 2.71436 6.21439V21.0715C2.71436 21.3871 2.97022 21.643 3.28578 21.643C4.54614 21.643 5.5715 22.6683 5.5715 23.9287C5.5715 24.2442 5.82736 24.5001 6.14293 24.5001H31.2858C31.6014 24.5001 31.8573 24.2442 31.8573 23.9287C31.8573 23.5124 31.9696 23.1223 32.1647 22.7858H7.85721Z"
        fill="#959BA4"
      />
      <path
        d="M24.4287 6.78592H13.0001C12.6845 6.78592 12.4287 6.53007 12.4287 6.21449C12.4287 5.89892 12.6845 5.64307 13.0001 5.64307H24.4287C24.7443 5.64307 25.0001 5.89892 25.0001 6.21449C25.0001 6.53007 24.7443 6.78592 24.4287 6.78592Z"
        fill="#959BA4"
      />
      <path
        d="M21.0002 9.07157H16.4287C16.1131 9.07157 15.8573 8.81572 15.8573 8.50014C15.8573 8.18456 16.1131 7.92871 16.4287 7.92871H21.0002C21.3157 7.92871 21.5716 8.18456 21.5716 8.50014C21.5716 8.81572 21.3157 9.07157 21.0002 9.07157Z"
        fill="#959BA4"
      />
      <path
        d="M14.7144 12.5003H11.2858C10.9702 12.5003 10.7144 12.2444 10.7144 11.9288C10.7144 11.6133 10.9702 11.3574 11.2858 11.3574H14.7144C15.0299 11.3574 15.2858 11.6133 15.2858 11.9288C15.2858 12.2444 15.0299 12.5003 14.7144 12.5003Z"
        fill="#B0B4BB"
      />
      <path
        d="M25 12.5003H17C16.6845 12.5003 16.4286 12.2444 16.4286 11.9288C16.4286 11.6133 16.6845 11.3574 17 11.3574H25C25.3156 11.3574 25.5714 11.6133 25.5714 11.9288C25.5714 12.2444 25.3156 12.5003 25 12.5003Z"
        fill="#B0B4BB"
      />
      <path
        d="M13 15.9285H9.57143C9.25585 15.9285 9 15.6726 9 15.3571C9 15.0415 9.25585 14.7856 9.57143 14.7856H13C13.3155 14.7856 13.5714 15.0415 13.5714 15.3571C13.5714 15.6726 13.3155 15.9285 13 15.9285Z"
        fill="#959BA4"
      />
      <path
        d="M27.8572 15.9285H15.2857C14.9702 15.9285 14.7143 15.6726 14.7143 15.3571C14.7143 15.0415 14.9702 14.7856 15.2857 14.7856H27.8572C28.1727 14.7856 28.4286 15.0415 28.4286 15.3571C28.4286 15.6726 28.1727 15.9285 27.8572 15.9285Z"
        fill="#959BA4"
      />
      <path
        d="M19.2857 18.2141H9.57143C9.25585 18.2141 9 17.9583 9 17.6427C9 17.3272 9.25585 17.0713 9.57143 17.0713H19.2857C19.6013 17.0713 19.8571 17.3272 19.8571 17.6427C19.8571 17.9583 19.6013 18.2141 19.2857 18.2141Z"
        fill="#959BA4"
      />
      <path
        d="M25.5714 18.2141H21.5714C21.2559 18.2141 21 17.9583 21 17.6427C21 17.3272 21.2559 17.0713 21.5714 17.0713H25.5714C25.887 17.0713 26.1429 17.3272 26.1429 17.6427C26.1429 17.9583 25.887 18.2141 25.5714 18.2141Z"
        fill="#959BA4"
      />
      <path
        d="M20.4287 26.7856H17.0001C16.6845 26.7856 16.4287 27.0415 16.4287 27.3571V31.9285C16.4287 32.3118 16.8168 32.592 17.1808 32.4706L18.7144 31.9594L20.2479 32.4706C20.6123 32.5919 21.0001 32.3117 21.0001 31.9285V27.3571C21.0001 27.0414 20.7443 26.7856 20.4287 26.7856Z"
        fill="#EFB30C"
      />
      <mask
        id="mask0"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="16"
        y="26"
        width="6"
        height="7"
      >
        <path
          d="M20.4287 26.7856H17.0001C16.6845 26.7856 16.4287 27.0415 16.4287 27.3571V31.9285C16.4287 32.3118 16.8168 32.592 17.1808 32.4706L18.7144 31.9594L20.2479 32.4706C20.6123 32.5919 21.0001 32.3117 21.0001 31.9285V27.3571C21.0001 27.0414 20.7443 26.7856 20.4287 26.7856Z"
          fill="#EFB30C"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          opacity="0.2"
          d="M18.7144 30.2146C21.2391 30.2146 23.2859 28.168 23.2859 25.6432C23.2859 23.1185 21.2391 21.0718 18.7144 21.0718C16.1896 21.0718 14.143 23.1185 14.143 25.6432C14.143 28.168 16.1896 30.2146 18.7144 30.2146Z"
          fill="#C46814"
        />
        <path
          d="M18.7144 28.4998C21.2391 28.4998 23.2859 26.453 23.2859 23.9284C23.2859 21.4036 21.2391 19.3569 18.7144 19.3569C16.1896 19.3569 14.143 21.4036 14.143 23.9284C14.143 26.453 16.1896 28.4998 18.7144 28.4998Z"
          fill="#EFB30C"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="36.5714" height="32" fill="white" transform="translate(0.428589 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const CHECK_SVG = (
  <svg viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 4.5L5 8.5L12.5 1" stroke="#B0B4BB" strokeWidth="1.5" />
  </svg>
);

export const CLOCK_IN_ICON_SVG = (
  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 2.76619V11.2338C1 12.0111 1.84797 12.4912 2.5145 12.0913L9.57084 7.85749C10.2182 7.46909 10.2182 6.53091 9.57084 6.14251L2.5145 1.9087C1.84797 1.50878 1 1.9889 1 2.76619Z"
      stroke="#283847"
      strokeWidth="2"
    />
  </svg>
);

export const CLOCK_OUT_ICON_SVG = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="10" height="10" rx="2" stroke="#283847" strokeWidth="2" />
  </svg>
);

export const CHEVRON_LEFT_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="6 0 8 18" fill="none">
    <path d="M10 0.999999L2 9L10 17" stroke="#CACDD1" strokeWidth="2" />
  </svg>
);

export const DOUBLE_CHEVRON_LEFT_SVG = (
  <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 1.5L7.5 8.5L12.5 15.5" stroke="#283847" strokeWidth="2" />
    <path d="M6.5 1.5L1.5 8.5L6.5 15.5" stroke="#283847" strokeWidth="2" />
  </svg>
);

export const CHEVRON_RIGHT_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="6 0 8 18" fill="none">
    <path d="M8 0.999999L16 9L8 17" stroke="#CACDD1" strokeWidth="2" />
  </svg>
);

export const DOUBLE_CHEVRON_RIGHT_SVG = (
  <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 15.5L6.5 8.5L1.5 1.5" stroke="#283847" strokeWidth="2" />
    <path d="M7.5 15.5L12.5 8.5L7.5 1.5" stroke="#283847" strokeWidth="2" />
  </svg>
);

export const MAP_SVG = (
  <svg width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.68148 2.28164C6.92384 0.572788 4.07633 0.572788 2.31823 2.28164C0.560589 3.98961 0.560589 6.76069 2.31823 8.46823C2.31823 8.46823 5.49783 11.5001 5.49783 15C5.49783 11.5001 8.68103 8.46823 8.68103 8.46823C10.4396 6.76113 10.4396 3.98961 8.68148 2.28164Z"
      stroke="#7B828D"
      strokeWidth="2"
    />
  </svg>
);

export const SORT_SVG = (
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 0V7" stroke="#7B828D" strokeWidth="2" />
    <path d="M1 5L4 8L7 5" stroke="#7B828D" strokeWidth="2" />
    <path d="M10 15V8" stroke="#7B828D" strokeWidth="2" />
    <path d="M13 10L10 7L7 10" stroke="#7B828D" strokeWidth="2" />
  </svg>
);

export const FILTERS_SVG = (
  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0V2H12V0H0ZM5 10H7V8H5V10ZM10 6H2V4H10V6Z"
      fill="#7B828D"
    />
  </svg>
);

export const CALENDAR_SVG = (
  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.8">
      <rect x="1" y="3" width="14" height="14" rx="2" stroke="#283847" strokeWidth="2" />
      <path d="M4 2.78947V1" stroke="#283847" strokeWidth="2" strokeLinecap="round" />
      <path d="M5 10V8" stroke="#283847" strokeWidth="2" />
      <path d="M2 5L14 5" stroke="#283847" strokeWidth="2" />
      <path d="M8 10V8" stroke="#283847" strokeWidth="2" />
      <path d="M11 10V8" stroke="#283847" strokeWidth="2" />
      <path d="M12 2.78947V1" stroke="#283847" strokeWidth="2" strokeLinecap="round" />
    </g>
  </svg>
);

export const NOTES_SVG = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="12" height="2" rx="1" fill="#B0B4BB" />
    <rect y="5" width="12" height="2" rx="1" fill="#B0B4BB" />
    <rect y="10" width="8" height="2" rx="1" fill="#B0B4BB" />
  </svg>
);

export const COPY_SVG = (
  <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 0C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H7V18H3C2.44772 18 2 17.5523 2 17V3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V5H16V3C16 1.34315 14.6569 0 13 0H3Z"
      fill="white"
    />
    <rect x="7" y="5" width="14" height="18" rx="2" stroke="white" strokeWidth="2" />
    <path opacity="0.2" d="M15 7V17C15 18.1046 14.1046 19 13 19H9" stroke="white" strokeWidth="2" />
  </svg>
);

export const CAMERA_SVG = (
  <svg width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5 8C11.0186 8 9 10.0186 9 12.5C9 14.9814 11.0186 17 13.5 17C15.9814 17 18 14.9814 18 12.5C18 10.0186 15.9814 8 13.5 8Z"
      stroke="#1CB394"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.56156 0C8.34268 0 7.24496 0.737474 6.78418 1.8659L5.87943 4.08163H3.5H2.99958C1.36392 4.08163 0 5.38838 0 7.04041V19.0273C0 20.6867 1.37059 22 3.01375 22H23.9862C25.6294 22 27 20.6867 27 19.0273V18.7324C26.7058 18.9026 26.3643 19 26 19C25.6357 19 25.2942 18.9026 25 18.7324V19.0273C25 19.5435 24.5639 20 23.9862 20H3.01375C2.43608 20 2 19.5435 2 19.0273V7.04041C2 6.53162 2.42941 6.08163 2.99958 6.08163H3.5H6C6.73967 6.08163 7.40581 5.6341 7.68543 4.94932L8.63577 2.62197C8.78936 2.24582 9.15527 2 9.56156 2H17.4384C17.8447 2 18.2106 2.24582 18.3642 2.62197L19.015 4.21573C19.4758 5.34416 20.5735 6.08163 21.7924 6.08163H24.0004C24.5706 6.08163 25 6.53162 25 7.04041V7.26756C25.2942 7.09739 25.6357 7 26 7C26.3643 7 26.7058 7.09739 27 7.26756V7.04041C27 5.38838 25.6361 4.08163 24.0004 4.08163H21.7924C21.3861 4.08163 21.0202 3.83581 20.8666 3.45966L20.2158 1.8659C19.755 0.737473 18.6573 0 17.4384 0H9.56156Z"
      fill="#1CB394"
    />
    <rect x="25" y="9" width="2" height="8" rx="1" fill="#1CB394" />
    <rect x="30" y="12" width="2" height="8" rx="1" transform="rotate(90 30 12)" fill="#1CB394" />
  </svg>
);

export const TIMES_SVG = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M13 1C8.31371 5.68629 5.68629 8.31371 1 13" stroke="#7B828D" strokeWidth="2" />
      <path
        d="M0.999999 1C5.68629 5.68629 8.31371 8.31371 13 13"
        stroke="#7B828D"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const VISIT_TYPE_SVG = (
  <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 0C3.9 0 3 0.89 3 2C1.34 2 0 3.34 0 5V17C0 18.66 1.34 20 3 20H13C14.66 20 16 18.66 16 17V5C16 3.34 14.66 2 13 2C13 0.89 12.1 0 11 0H5ZM10 4C10.55 4 11 3.55 11 3V2H10H9H7H6H5V3C5 3.52 5.39 3.94 5.9 3.99C5.93 4 5.96 4 6 4H10ZM3.17 4C3.58 5.17 4.69 6 6 6H10C11.31 6 12.42 5.17 12.83 4H13C13.55 4 14 4.45 14 5V17C14 17.55 13.55 18 13 18H3C2.45 18 2 17.55 2 17V5C2 4.45 2.45 4 3 4H3.17ZM4 10C4 9.45 4.45 9 5 9H11C11.55 9 12 9.45 12 10C12 10.55 11.55 11 11 11H5C4.45 11 4 10.55 4 10ZM5 13C4.45 13 4 13.45 4 14C4 14.55 4.45 15 5 15H11C11.55 15 12 14.55 12 14C12 13.45 11.55 13 11 13H5Z"
      fill="#7B828D"
    />
  </svg>
);

export const MAP_AVAILABLE_VISIT_SVG = (
  <svg width="25" height="36" viewBox="0 0 25 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.9235 5.07256C15.8223 0.975814 9.1781 0.975814 5.07588 5.07256C0.974707 9.1672 0.974707 15.8105 5.07588 19.9041C5.07588 19.9041 12.4949 27.1725 12.4949 35.5632C12.4949 27.1725 19.9224 19.9041 19.9224 19.9041C24.0257 15.8116 24.0257 9.1672 19.9235 5.07256Z"
      fill="white"
      stroke="#dd4277"
      strokeWidth="4"
    />
  </svg>
);

export const MAP_CAREGIVER_ALT_SVG = (
  <svg width="39" height="51" viewBox="0 0 39 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M37.9091 18.6818C37.9091 22.0057 36.7885 25.6055 35.0419 29.1803C33.2997 32.7462 30.9664 36.2235 28.6159 39.285C26.2676 42.3436 23.9169 44.9683 22.1523 46.8289C21.2706 47.7586 20.5366 48.496 20.0243 48.9999C19.9846 49.039 19.9462 49.0767 19.9091 49.1129C19.8721 49.0767 19.8337 49.039 19.7939 48.9999C19.2816 48.496 18.5477 47.7586 17.6659 46.8289C15.9014 44.9683 13.5506 42.3436 11.2023 39.285C8.85183 36.2235 6.51856 32.7462 4.77637 29.1803C3.02978 25.6055 1.90912 22.0057 1.90912 18.6818C1.90912 14.1395 3.79435 9.77378 7.16547 6.54782C10.5381 3.32044 15.1214 1.5 19.9091 1.5C24.6969 1.5 29.2801 3.32044 32.6528 6.54782C36.0239 9.77378 37.9091 14.1395 37.9091 18.6818Z"
      fill="#46A8FF"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.4137 14.2995C27.3573 13.2832 26.0052 12.7951 24.6425 12.7951C23.1087 12.7951 21.5597 13.4133 20.4047 14.5955C20.134 14.8722 19.6837 14.8711 19.4134 14.594C18.2584 13.4133 16.7094 12.7951 15.1756 12.7951C13.8129 12.7951 12.4609 13.2832 11.4045 14.2995C9.08096 16.5352 9.03997 20.2753 11.2802 22.5652L18.9846 30.4406C19.4897 30.957 20.3284 30.957 20.8335 30.4406L28.5379 22.5652C30.7781 20.2753 30.7372 16.5352 28.4137 14.2995Z"
      fill="white"
    />
  </svg>
);

export const MAP_CAREGIVER_SVG = (
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d)">
      <circle cx="26" cy="24" r="16" fill="#46A8FF" />
      <circle cx="26" cy="24" r="17" stroke="white" strokeOpacity="0.6" strokeWidth="2" />
      <path
        d="M32.6192 18.5202C31.797 17.7184 30.7447 17.3333 29.6841 17.3333C28.4903 17.3333 27.2847 17.821 26.3858 18.7537C26.1751 18.972 25.8246 18.9711 25.6142 18.7525C24.7153 17.821 23.5097 17.3333 22.3159 17.3333C21.2553 17.3333 20.203 17.7184 19.3808 18.5202C17.5724 20.284 17.5405 23.2347 19.2841 25.0413L25.2805 31.2544C25.6736 31.6618 26.3264 31.6618 26.7195 31.2544L32.7159 25.0413C34.4595 23.2347 34.4276 20.284 32.6192 18.5202Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0"
        y="0"
        width="52"
        height="52"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.179236 0 0 0 0 0.477172 0 0 0 0 0.741667 0 0 0 0.4 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const ARROW_LEFT_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 1L1 8L8 15"
      stroke="#F4F7FB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2 8L15 8" stroke="#F4F7FB" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
export const ARROW_RIGHT_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 8H15"
      stroke="#3778E0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 1L15 8L8 15"
      stroke="#3778E0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ARROW_LEFT_BLACK_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 1L1 8L8 15"
      stroke="#000000"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2 8L15 8" stroke="#000000" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const STAR_SVG = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.72142 15.2539L4.48557 22.8415C4.38705 23.4443 5.02985 23.8966 5.56145 23.6006L11.9894 20.0427L18.4174 23.6016C18.9442 23.8946 19.5928 23.4511 19.4933 22.8425L18.2575 15.2549L23.4857 9.88776C23.9003 9.46281 23.6623 8.74185 23.0731 8.65198L15.8765 7.551L12.6508 0.669683C12.4099 0.155831 11.5681 0.155831 11.3271 0.669683L8.10241 7.55003L0.905788 8.651C0.314685 8.74185 0.0786343 9.46183 0.493186 9.88678L5.72142 15.2539Z"
      fill="#FEBB2C"
    />
  </svg>
);

export const STAR2_SVG = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.3099 8.14736C16.7748 8.03647 12.5564 8.78302 10.6718 4.98254C9.78596 3.19961 9.84748 1.21723 9.8596 0.968692C9.92302 0.538494 9.62424 0.101135 9.15259 0.0150956C8.73151 -0.0682059 8.25985 0.198864 8.15081 0.677506C8.09456 0.922882 8.503 5.18874 5.40644 7.16796C3.46104 8.40854 1.19053 8.08807 0.7626 8.13578C-0.198932 8.24509 -0.27668 9.63194 0.674949 9.84857C1.13449 9.95198 3.4188 9.53769 5.44658 10.8572C7.60773 12.2646 8.05684 14.8494 8.13111 16.2786C8.14133 17.0954 8.1052 17.1904 8.16936 17.3894C8.28745 17.7547 8.62131 18 8.99994 18C9.43461 18.0002 9.7868 17.6789 9.85654 17.2851C9.90479 17.0151 9.69388 14.9611 10.6947 12.9732C10.8909 12.5834 10.7339 12.1086 10.3441 11.9124C9.9542 11.7161 9.47918 11.8732 9.28291 12.2628C9.18304 12.4613 9.09022 12.6672 9.00457 12.8795C8.28303 11.1115 7.04558 9.76706 5.32606 8.99976C7.07814 8.21782 8.29704 6.85119 9.0032 5.12334C9.70894 6.86383 10.918 8.22456 12.6776 9.00249C12.5052 9.07863 12.3327 9.16257 12.1615 9.25503C11.7775 9.4626 11.6347 9.94187 11.8425 10.3257C12.0501 10.7095 12.5295 10.8522 12.9136 10.6447C14.7787 9.63605 16.8164 9.91038 17.2375 9.86352C18.2041 9.75273 18.2774 8.35198 17.3099 8.14736Z"
      fill="#99DF63"
    />
  </svg>
);

export const HEART_OUTLINE_SVG = (
  <svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M29.4153 2.58749C27.7396 0.927464 25.5213 0.0201623 23.1537 0.0201623C20.7861 0.0201623 18.5609 0.934185 16.8853 2.59421L16.0102 3.46119L15.1215 2.58077C13.4458 0.920743 11.2139 0 8.84632 0C6.4855 0 4.26036 0.914022 2.59151 2.56733C0.915871 4.22735 -0.00674681 6.43176 3.7147e-05 8.77731C3.7147e-05 11.1228 0.929439 13.3205 2.60508 14.9806L15.3453 27.6021C15.5217 27.7769 15.7592 27.871 15.9898 27.871C16.2205 27.871 16.4579 27.7836 16.6343 27.6089L29.4017 15.0074C31.0773 13.3474 32 11.143 32 8.79747C32.0067 6.45192 31.0909 4.24752 29.4153 2.58749ZM28.1128 13.7238L15.9898 25.6867L3.89403 13.7036C2.56437 12.3864 1.83171 10.639 1.83171 8.77731C1.83171 6.91566 2.55759 5.16826 3.88724 3.85771C5.21012 2.54717 6.97394 1.82132 8.84632 1.82132C10.7255 1.82132 12.4961 2.54717 13.8257 3.86443L15.3589 5.38332C15.7185 5.73952 16.2951 5.73952 16.6547 5.38332L18.1743 3.87788C19.5039 2.56061 21.2745 1.83477 23.1469 1.83477C25.0193 1.83477 26.7831 2.56061 28.1128 3.87115C29.4424 5.18842 30.1683 6.93582 30.1683 8.79747C30.1751 10.6591 29.4424 12.4065 28.1128 13.7238Z"
      fill="white"
    />
  </svg>
);

export const PLUS_THICK_SVG = (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.2002 1C25.2002 0.447715 24.7525 0 24.2002 0H11.8002C11.2479 0 10.8002 0.447715 10.8002 1L10.8002 10.8H1C0.447715 10.8 0 11.2477 0 11.8V24.2C0 24.7523 0.447716 25.2 1 25.2H10.8002L10.8002 35C10.8002 35.5523 11.2479 36 11.8002 36H24.2002C24.7525 36 25.2002 35.5523 25.2002 35V25.2H35C35.5523 25.2 36 24.7523 36 24.2V11.8C36 11.2477 35.5523 10.8 35 10.8H25.2002V1Z"
      fill="white"
    />
  </svg>
);

export const TORSO_SVG = (
  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.8">
      <circle cx="6" cy="5" r="4" stroke="#283847" strokeWidth="2" />
      <path
        d="M1 14C1 12.6739 1.52678 11.4021 2.46447 10.4645C3.40215 9.52678 4.67392 9 6 9C7.32608 9 8.59785 9.52678 9.53553 10.4645C10.4732 11.4021 11 12.6739 11 14"
        stroke="#283847"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const CLOCK_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.8">
      <circle cx="8" cy="8" r="7" stroke="#283847" strokeWidth="2" />
      <path
        d="M8 4.11111V8L10.3333 10.3333"
        stroke="#283847"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const MARKER_SVG = (
  <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.8">
      <path
        d="M11.242 2.64782C8.89845 0.450727 5.10177 0.450727 2.75765 2.64782C0.414118 4.84378 0.414118 8.4066 2.75765 10.602C2.75765 10.602 6.99711 14.5001 6.99711 19C6.99711 14.5001 11.2414 10.602 11.2414 10.602C13.5861 8.40717 13.5861 4.84378 11.242 2.64782Z"
        stroke="#283847"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const CALL_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.34307 1.02132C4.21784 0.213975 5.59985 0.344782 6.30761 1.30191L8.94656 4.87065C9.53374 5.66471 9.45342 6.76848 8.75748 7.46918L8.09182 8.13937L13.8323 13.9156L15.0772 12.8492C15.8468 12.1899 16.9879 12.2105 17.7332 12.897L20.9116 15.8243C21.7458 16.5926 21.7749 17.9001 20.9757 18.7048L18.7245 20.9714C18.6784 21.0177 18.6084 21.0842 18.515 21.1506C18.1394 21.4176 16.7716 22.23 14.4884 21.9375C12.2213 21.647 9.19499 20.2853 5.44771 16.5124C1.74364 12.7831 0.381658 9.76545 0.0725028 7.49685C-0.238844 5.21218 0.535851 3.82215 0.822117 3.40252C0.908282 3.27621 0.999818 3.18396 1.06786 3.12116L3.34307 1.02132ZM4.69951 2.49104L2.44965 4.56748C2.31838 4.77763 1.84136 5.66504 2.05419 7.2268C2.28655 8.93191 3.359 11.5714 6.86673 15.103C10.4164 18.6769 13.0562 19.7377 14.7425 19.9537C16.2867 20.1516 17.1494 19.6562 17.3267 19.5405L19.5567 17.2954L16.3783 14.3681L15.1334 15.4345C14.3381 16.1158 13.1519 16.0682 12.4137 15.3254L6.67322 9.54918C5.89818 8.76931 5.898 7.51007 6.67281 6.72997L7.33846 6.05978L4.69951 2.49104ZM2.42429 4.59087C2.42381 4.59134 2.42356 4.59158 2.42355 4.59158C2.42355 4.59158 2.42379 4.59134 2.42429 4.59087Z"
      fill="#1CB394"
    />
  </svg>
);

export const MOBILE_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 3C0 1.34315 1.34315 0 3 0H11C12.6569 0 14 1.34315 14 3V19C14 20.6569 12.6569 22 11 22H3C1.34315 22 0 20.6569 0 19V3ZM3 2C2.44772 2 2 2.44772 2 3V19C2 19.5523 2.44772 20 3 20H11C11.5523 20 12 19.5523 12 19V3C12 2.44772 11.5523 2 11 2H3Z"
      fill="#1CB394"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 18C5 17.4477 5.44772 17 6 17L8 17C8.55228 17 9 17.4477 9 18C9 18.5523 8.55228 19 8 19L6 19C5.44772 19 5 18.5523 5 18Z"
      fill="#1CB394"
    />
  </svg>
);

export const MESSAGE_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 12.07V3.02C0 1.35 1.34 0 3 0H17C18.66 0 20 1.35 20 3.02V12.07C20 13.74 18.66 15.09 17 15.09H12.75L10.15 17.38C8.53 18.8 6 17.64 6 15.48V15.08H3C1.34 15.08 0 13.73 0 12.07ZM7.76 14.13C7.42 13.5 6.76 13.07 6 13.07H3C2.45 13.07 2 12.62 2 12.06V3.02C2 2.47 2.45 2.01 3 2.01H17C17.55 2.01 18 2.46 18 3.02V12.07C18 12.62 17.55 13.08 17 13.08H12.75C12.27 13.08 11.8 13.26 11.43 13.58L8.83 15.87C8.51 16.14 8 15.91 8 15.48V15.08C8 15.02 8 14.96 7.99 14.9C7.97 14.63 7.89 14.38 7.78 14.16L7.76 14.13ZM5 6C5 5.45 5.45 5 6 5H14C14.55 5 15 5.45 15 6C15 6.55 14.55 7 14 7H6C5.45 7 5 6.55 5 6ZM6 8C5.45 8 5 8.45 5 9C5 9.55 5.45 10 6 10H11C11.55 10 12 9.55 12 9C12 8.45 11.55 8 11 8H6Z"
      fill="#FFF"
    />
  </svg>
);

export const NAVIGATE_SVG = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0C4.48 0 0 4.48 0 10ZM2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18C5.58 18 2 14.42 2 10ZM14.03 7.04C14.2 6.66 14.12 6.21 13.83 5.92C13.53 5.62 13.09 5.54 12.71 5.72L4.93 9.25C4.63 9.39 4.42 9.66 4.36 9.98C4.3 10.3 4.4 10.63 4.64 10.86L8.88 15.1C9.11 15.33 9.44 15.43 9.76 15.38C10.09 15.32 10.36 15.11 10.5 14.81L14.03 7.04ZM9.27 12.67L7.07 10.47L11.11 8.64L9.27 12.67Z"
      fill="#7B828D"
    />
  </svg>
);

export const CLOCK_IN_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
    <path
      d="M1 2.76619V11.2338C1 12.0111 1.84797 12.4912 2.5145 12.0913L9.57084 7.85749C10.2182 7.46909 10.2182 6.53091 9.57084 6.14251L2.5145 1.9087C1.84797 1.50878 1 1.9889 1 2.76619Z"
      stroke="#283847"
      strokeWidth="2"
    />
  </svg>
);

export const CLOCK_OUT_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <rect x="1" y="1" width="10" height="10" rx="2" stroke="#283847" strokeWidth="2" />
  </svg>
);

export const MOON_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M6.9993 13.9996C9.67762 14.0278 12.1242 12.4845 13.2523 10.0553C12.5423 10.3651 11.7734 10.5168 10.9989 10.5C7.96307 10.4966 5.50287 8.03635 5.49945 5.00052C5.52984 2.94701 6.66291 1.06866 8.4651 0.0837702C7.97906 0.0218867 7.48924 -0.00582048 6.9993 0.00101477C3.1336 0.00101477 0 3.13474 0 7.00032C0 10.866 3.1336 13.9996 6.9993 13.9996Z"
      fill="#B0B4BB"
    />
  </svg>
);

export const SUN_SVG = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 10C8.65685 10 10 8.65685 10 7C10 5.34315 8.65685 4 7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10Z"
      fill="#B0B4BB"
    />
    <path
      d="M8 2V1C8 0.447715 7.55228 0 7 0C6.44772 0 6 0.447715 6 1V2C6 2.55228 6.44772 3 7 3C7.55228 3 8 2.55228 8 2Z"
      fill="#B0B4BB"
    />
    <path
      d="M8 13V12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12V13C6 13.5523 6.44772 14 7 14C7.55228 14 8 13.5523 8 13Z"
      fill="#B0B4BB"
    />
    <path
      d="M12 8H13C13.5523 8 14 7.55228 14 7C14 6.44772 13.5523 6 13 6H12C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8Z"
      fill="#B0B4BB"
    />
    <path
      d="M1 8H2C2.55228 8 3 7.55228 3 7C3 6.44772 2.55228 6 2 6H1C0.447715 6 0 6.44772 0 7C0 7.55228 0.447715 8 1 8Z"
      fill="#B0B4BB"
    />
    <path
      d="M11.2427 4.17169L11.9498 3.46458C12.3403 3.07406 12.3403 2.44089 11.9498 2.05037C11.5593 1.65984 10.9261 1.65984 10.5356 2.05037L9.82846 2.75748C9.43794 3.148 9.43794 3.78116 9.82846 4.17169C10.219 4.56221 10.8522 4.56221 11.2427 4.17169Z"
      fill="#B0B4BB"
    />
    <path
      d="M3.46436 11.9498L4.17146 11.2427C4.56199 10.8521 4.56199 10.219 4.17146 9.82844C3.78094 9.43792 3.14777 9.43792 2.75725 9.82844L2.05014 10.5356C1.65962 10.9261 1.65962 11.5592 2.05014 11.9498C2.44067 12.3403 3.07383 12.3403 3.46436 11.9498Z"
      fill="#B0B4BB"
    />
    <path
      d="M9.82831 11.2427L10.5354 11.9498C10.9259 12.3403 11.5591 12.3403 11.9496 11.9498C12.3402 11.5593 12.3402 10.9261 11.9496 10.5356L11.2425 9.82846C10.852 9.43794 10.2188 9.43794 9.82831 9.82846C9.43779 10.219 9.43779 10.8522 9.82831 11.2427Z"
      fill="#B0B4BB"
    />
    <path
      d="M2.04999 3.4646L2.7571 4.17171C3.14762 4.56223 3.78079 4.56223 4.17131 4.17171C4.56184 3.78118 4.56184 3.14802 4.17131 2.75749L3.4642 2.05039C3.07368 1.65986 2.44052 1.65986 2.04999 2.05039C1.65947 2.44091 1.65947 3.07408 2.04999 3.4646Z"
      fill="#B0B4BB"
    />
  </svg>
);

export const SEND_MESSAGE_SVG = (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 14L16 7L0 0V5.44444L11.4286 7L0 8.55556V14Z" fill="black" />
  </svg>
);

export const ASSIST_SVG = (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 6.5C1 2.91015 3.91015 0 7.5 0C11.0899 0 14 2.91015 14 6.5V11H12V6.5C12 4.01472 9.98528 2 7.5 2C5.01472 2 3 4.01472 3 6.5V11H1V6.5Z"
      fill="#53606C"
    />
    <path d="M0 9C0 8.44772 0.447715 8 1 8H4V13H1C0.447715 13 0 12.5523 0 12V9Z" fill="#53606C" />
    <path
      d="M15 9C15 8.44772 14.5523 8 14 8H11V13H14C14.5523 13 15 12.5523 15 12V9Z"
      fill="#53606C"
    />
    <circle cx="8.5" cy="14.5" r="1.5" fill="#53606C" />
    <rect x="12" y="12" width="1" height="3" fill="#53606C" />
    <rect x="8" y="15" width="1" height="5" transform="rotate(-90 8 15)" fill="#53606C" />
  </svg>
);

export const BACKWARDS_SVG = (
  <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.4125 1.94C5.77798 1.35524 6.41892 1 7.1085 1H21C22.1046 1 23 1.89543 23 3V15C23 16.1046 22.1046 17 21 17H7.1085C6.41892 17 5.77798 16.6448 5.4125 16.06L1.6625 10.06C1.25716 9.41146 1.25716 8.58854 1.6625 7.94L5.4125 1.94Z"
      stroke="#283847"
      strokeWidth="2"
    />
    <g>
      <path d="M18 5C14.8758 8.12419 13.1242 9.87581 10 13" stroke="#283847" strokeWidth="2" />
      <path d="M10 5C13.1242 8.12419 14.8758 9.87581 18 13" stroke="#283847" strokeWidth="2" />
    </g>
  </svg>
);

export const TORSO_ALT_SVG = (
  <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5" cy="3" r="3" fill="white" />
    <rect y="7" width="10" height="5" rx="2" fill="white" />
  </svg>
);

export const TRAINING_CENTER_SVG = (
  <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="2" width="14" height="18" rx="1" stroke="#8F969F" strokeWidth="2" />
    <path d="M8 0H12V6L8 7V0Z" fill="#8F969F" />
  </svg>
);

export const EDUCATION_CENTER_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="14" height="14" rx="1" stroke="#8F969F" strokeWidth="2" />
    <path
      d="M10.765 8.42416L6.765 10.9241C6.68406 10.9746 6.59203 11 6.5 11C6.41662 11 6.33313 10.9793 6.25756 10.9373C6.09863 10.8491 6 10.6819 6 10.5V5.50021C6 5.31834 6.09863 5.1511 6.25756 5.06298C6.4165 4.97436 6.61084 4.97973 6.765 5.07616L10.765 7.57607C10.9111 7.66763 11 7.82778 11 8.00011C11 8.17245 10.9111 8.33263 10.765 8.42416Z"
      fill="#8F969F"
    />
  </svg>
);

export const PASSPORT_SVG = (
  <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="19"
      y="1"
      width="13"
      height="18"
      rx="1"
      transform="rotate(90 19 1)"
      stroke="#8F969F"
      strokeWidth="2"
    />
    <circle cx="7" cy="6" r="2" fill="#8F969F" />
    <path
      d="M9 11C9.55228 11 10.0156 10.5403 9.83487 10.0184C9.81547 9.96238 9.79439 9.90687 9.77164 9.85195C9.62087 9.48797 9.3999 9.15726 9.12132 8.87868C8.84274 8.6001 8.51203 8.37913 8.14805 8.22836C7.78407 8.0776 7.39397 8 7 8C6.60603 8 6.21593 8.0776 5.85195 8.22836C5.48797 8.37913 5.15726 8.6001 4.87868 8.87868C4.6001 9.15726 4.37913 9.48797 4.22836 9.85195C4.20561 9.90687 4.18453 9.96238 4.16513 10.0184C3.98442 10.5403 4.44772 11 5 11L7 11H9Z"
      fill="#8F969F"
    />
    <rect x="11" y="5" width="5" height="2" rx="1" fill="#8F969F" />
    <rect x="11" y="8" width="3" height="2" rx="1" fill="#8F969F" />
  </svg>
);

export const MY_AGENCIES_SVG = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 6V7H7V6H6ZM6 12H7V11H6V12ZM12 12V11H11V12H12ZM12 6H11V7H12V6ZM7 2V0C5.89543 0 5 0.89543 5 2H7ZM7 6V2H5V6H7ZM2 7H6V5H2V7ZM2 7V5C0.89543 5 0 5.89543 0 7H2ZM2 11V7H0V11H2ZM2 11H2H0C0 12.1046 0.89543 13 2 13V11ZM6 11H2V13H6V11ZM7 16V12H5V16H7ZM7 16H5C5 17.1046 5.89543 18 7 18V16ZM11 16H7V18H11V16ZM11 16V18C12.1046 18 13 17.1046 13 16H11ZM11 12V16H13V12H11ZM16 11H12V13H16V11ZM16 11V13C17.1046 13 18 12.1046 18 11H16ZM16 7V11H18V7H16ZM16 7H18C18 5.89543 17.1046 5 16 5V7ZM12 7H16V5H12V7ZM11 2V6H13V2H11ZM11 2H13C13 0.89543 12.1046 0 11 0V2ZM7 2H11V0H7V2Z"
      fill="#8F969F"
    />
  </svg>
);

export const USER_SQUARE_FILL_SVG = (
  <svg width="32" height="32" opacity="0.6" viewBox="0 0 256 256">
    <path
      fill="currentColor"
      d="M172 120a44 44 0 1 1-44-44a44 44 0 0 1 44 44Zm52-72v160a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16Zm-16 160V48H48v160h3.7a80.7 80.7 0 0 1 26-38.2a76.8 76.8 0 0 1 9-6.3a59.9 59.9 0 0 0 82.6 0a76.8 76.8 0 0 1 9 6.3a80.7 80.7 0 0 1 26 38.2Z"
    />
  </svg>
);

export const CONTACT_SUPPORT_SVG = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.75 13.4188L13.9788 10.661C13.6455 10.3294 13.1052 10.3294 12.772 10.661L12.1595 11.2705C11.8425 11.586 11.3526 11.6557 10.9749 11.4162C9.22596 10.3072 7.7311 8.82049 6.61562 7.08075C6.37243 6.70147 6.44292 6.20723 6.76228 5.88942L7.44762 5.2074C7.7809 4.87577 7.7809 4.33804 7.44762 4.0064L4.6764 1.24873C4.34311 0.917091 3.80281 0.917091 3.46956 1.24873L1.70318 3.00654C1.70139 3.00833 1.70139 3.01123 1.70318 3.01301V3.01301C1.7051 3.01493 1.70493 3.01809 1.70284 3.0198C1.07919 3.52959 0.824104 4.40892 1.12808 5.27563C3.01573 10.6587 7.3721 14.9939 12.7813 16.8724C13.6145 17.1618 14.4568 16.9426 14.9777 16.38C14.9782 16.3795 14.979 16.3795 14.9795 16.38V16.38C14.98 16.3805 14.9808 16.3805 14.9813 16.38L16.75 14.6198C17.0833 14.2882 17.0833 13.7505 16.75 13.4188Z"
      stroke="#8F969F"
      strokeWidth="2"
    />
  </svg>
);

export const CASE_SETTINGS_SVG = (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect opacity="0.4" y="2" width="18" height="2" rx="1" fill="currentColor" />
    <rect y="2" width="13" height="2" rx="1" fill="currentColor" />
    <rect opacity="0.4" y="9" width="18" height="2" rx="1" fill="currentColor" />
    <rect y="9" width="6" height="2" rx="1" fill="currentColor" />
    <rect opacity="0.4" y="16" width="18" height="2" rx="1" fill="currentColor" />
    <rect y="16" width="18" height="2" rx="1" fill="currentColor" />
    <circle cx="10" cy="3" r="2" fill="white" stroke="currentColor" strokeWidth="2" />
    <circle cx="5" cy="10" r="2" fill="white" stroke="currentColor" strokeWidth="2" />
    <circle cx="15" cy="17" r="2" fill="white" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const SETTINGS_SVG = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.6235 7.17822L16.8363 6.20112L16.836 6.20105L16.6235 7.17822ZM15.3938 6.91089L14.4432 7.22137L14.6212 7.76629L15.1814 7.88806L15.3938 6.91089ZM16.6235 10.8218L16.836 11.799L16.8363 11.7989L16.6235 10.8218ZM15.3938 11.0891L15.1814 10.1119L14.6212 10.2337L14.4432 10.7786L15.3938 11.0891ZM14.998 12.0435L14.1066 11.5903L13.8467 12.1017L14.1569 12.5842L14.998 12.0435ZM15.6788 13.1024L16.5201 12.5618L16.52 12.5616L15.6788 13.1024ZM13.699 15.6147L12.9919 14.9076L12.9916 14.9079L13.699 15.6147ZM13.1024 15.6788L12.5616 16.52L12.5618 16.5201L13.1024 15.6788ZM12.0435 14.998L12.5842 14.1569L12.1017 13.8467L11.5903 14.1066L12.0435 14.998ZM11.0891 15.3938L10.7786 14.4432L10.2337 14.6212L10.1119 15.1814L11.0891 15.3938ZM10.8218 16.6235L9.8446 16.4111L9.84457 16.4113L10.8218 16.6235ZM7.17822 16.6235L8.15543 16.4113L8.1554 16.4111L7.17822 16.6235ZM6.91089 15.3938L7.88806 15.1814L7.76629 14.6212L7.22137 14.4432L6.91089 15.3938ZM5.95654 14.998L6.40969 14.1066L5.89831 13.8467L5.41577 14.1569L5.95654 14.998ZM4.89758 15.6788L5.43818 16.5201L5.43836 16.52L4.89758 15.6788ZM2.32117 13.1024L1.48 12.5616L1.47988 12.5618L2.32117 13.1024ZM3.00195 12.0435L3.84312 12.5842L4.15334 12.1017L3.89339 11.5903L3.00195 12.0435ZM2.6062 11.0891L3.55678 10.7786L3.3788 10.2337L2.81863 10.1119L2.6062 11.0891ZM1.37646 10.8218L1.16367 11.7989L1.16404 11.799L1.37646 10.8218ZM1.37646 7.17822L1.16404 6.20105L1.16367 6.20112L1.37646 7.17822ZM2.6062 6.91089L2.81863 7.88806L3.3788 7.76629L3.55678 7.22137L2.6062 6.91089ZM3.00195 5.95654L3.89339 6.40969L4.15334 5.89831L3.84312 5.41577L3.00195 5.95654ZM2.32117 4.89758L1.47988 5.43818L1.48 5.43836L2.32117 4.89758ZM4.89758 2.32117L5.43836 1.48L5.43818 1.47988L4.89758 2.32117ZM5.95654 3.00195L5.41577 3.84312L5.89831 4.15334L6.40969 3.89339L5.95654 3.00195ZM6.91089 2.6062L7.22137 3.55678L7.76629 3.3788L7.88806 2.81863L6.91089 2.6062ZM7.17822 1.37646L8.1554 1.58889L8.15543 1.58874L7.17822 1.37646ZM10.8218 1.37646L9.84457 1.58874L9.8446 1.58889L10.8218 1.37646ZM11.0891 2.6062L10.1119 2.81863L10.2337 3.3788L10.7786 3.55678L11.0891 2.6062ZM12.0435 3.00195L11.5903 3.89339L12.1017 4.15334L12.5842 3.84312L12.0435 3.00195ZM13.1024 2.32117L12.5618 1.47988L12.5616 1.48L13.1024 2.32117ZM15.6788 4.89758L16.52 5.43836L16.5201 5.43818L15.6788 4.89758ZM14.998 5.95654L14.1569 5.41577L13.8467 5.89831L14.1066 6.40969L14.998 5.95654ZM16.836 6.20105L15.6062 5.93371L15.1814 7.88806L16.4111 8.1554L16.836 6.20105ZM18 7.64539C18 6.94999 17.5153 6.349 16.8363 6.20112L16.4107 8.15532C16.1712 8.10315 16 7.89107 16 7.64539H18ZM18 10.3546V7.64539H16V10.3546H18ZM16.8363 11.7989C17.5153 11.651 18 11.05 18 10.3546H16C16 10.1089 16.1712 9.89685 16.4107 9.84468L16.8363 11.7989ZM15.6062 12.0663L16.836 11.799L16.4111 9.8446L15.1814 10.1119L15.6062 12.0663ZM15.8895 12.4966C16.0691 12.1432 16.2214 11.7761 16.3444 11.3996L14.4432 10.7786C14.3523 11.0569 14.2397 11.3285 14.1066 11.5903L15.8895 12.4966ZM16.52 12.5616L15.8392 11.5027L14.1569 12.5842L14.8377 13.6432L16.52 12.5616ZM16.3219 14.4061C16.8134 13.9145 16.8959 13.1467 16.5201 12.5618L14.8375 13.643C14.7049 13.4366 14.7339 13.1656 14.9076 12.9919L16.3219 14.4061ZM14.4061 16.3219L16.3219 14.4061L14.9076 12.9919L12.9919 14.9076L14.4061 16.3219ZM12.5618 16.5201C13.1463 16.8957 13.9144 16.8139 14.4064 16.3216L12.9916 14.9079C13.1657 14.7337 13.437 14.7051 13.643 14.8375L12.5618 16.5201ZM11.5027 15.8392L12.5616 16.52L13.6432 14.8377L12.5842 14.1569L11.5027 15.8392ZM11.3996 16.3444C11.7761 16.2214 12.1432 16.0691 12.4966 15.8895L11.5903 14.1066C11.3285 14.2397 11.0569 14.3523 10.7786 14.4432L11.3996 16.3444ZM11.799 16.836L12.0663 15.6062L10.1119 15.1814L9.8446 16.4111L11.799 16.836ZM10.3546 18C11.0496 18 11.6513 17.5156 11.799 16.8358L9.84457 16.4113C9.89678 16.1709 10.1093 16 10.3546 16V18ZM7.64539 18H10.3546V16H7.64539V18ZM6.20101 16.8358C6.34869 17.5156 6.9504 18 7.64539 18V16C7.89066 16 8.10322 16.1709 8.15543 16.4113L6.20101 16.8358ZM5.93371 15.6062L6.20105 16.836L8.1554 16.4111L7.88806 15.1814L5.93371 15.6062ZM5.5034 15.8895C5.85683 16.0691 6.22385 16.2214 6.60041 16.3444L7.22137 14.4432C6.94314 14.3523 6.67149 14.2397 6.40969 14.1066L5.5034 15.8895ZM5.43836 16.52L6.49732 15.8392L5.41577 14.1569L4.35681 14.8377L5.43836 16.52ZM3.59392 16.3219C4.08551 16.8134 4.85335 16.8959 5.43818 16.5201L4.35699 14.8375C4.5634 14.7049 4.83441 14.7339 5.00813 14.9076L3.59392 16.3219ZM1.67815 14.4061L3.59392 16.3219L5.00813 14.9076L3.09236 12.9919L1.67815 14.4061ZM1.47988 12.5618C1.10408 13.1467 1.18655 13.9145 1.67815 14.4061L3.09236 12.9919C3.26608 13.1656 3.29509 13.4366 3.16245 13.643L1.47988 12.5618ZM2.16078 11.5027L1.48 12.5616L3.16234 13.6432L3.84312 12.5842L2.16078 11.5027ZM1.65562 11.3996C1.77861 11.7761 1.93086 12.1432 2.11052 12.4966L3.89339 11.5903C3.76031 11.3285 3.64766 11.0569 3.55678 10.7786L1.65562 11.3996ZM1.16404 11.799L2.39377 12.0663L2.81863 10.1119L1.58889 9.8446L1.16404 11.799ZM0 10.3546C0 11.05 0.484678 11.651 1.16367 11.7989L1.58926 9.84468C1.8288 9.89685 2 10.1089 2 10.3546H0ZM0 7.64539V10.3546H2V7.64539H0ZM1.16367 6.20112C0.484678 6.349 0 6.94999 0 7.64539H2C2 7.89107 1.8288 8.10315 1.58926 8.15532L1.16367 6.20112ZM2.39377 5.93371L1.16404 6.20105L1.58889 8.1554L2.81863 7.88806L2.39377 5.93371ZM2.11052 5.5034C1.93086 5.85683 1.77861 6.22385 1.65562 6.60041L3.55678 7.22137C3.64766 6.94314 3.76031 6.67149 3.89339 6.40969L2.11052 5.5034ZM1.48 5.43836L2.16078 6.49732L3.84312 5.41577L3.16234 4.35681L1.48 5.43836ZM1.67815 3.59392C1.18655 4.08551 1.10408 4.85335 1.47988 5.43818L3.16245 4.35699C3.29509 4.5634 3.26608 4.83441 3.09236 5.00813L1.67815 3.59392ZM3.59392 1.67815L1.67815 3.59392L3.09236 5.00813L5.00813 3.09236L3.59392 1.67815ZM5.43818 1.47988C4.85335 1.10408 4.08551 1.18655 3.59392 1.67815L5.00813 3.09236C4.83441 3.26608 4.5634 3.29509 4.35699 3.16245L5.43818 1.47988ZM6.49732 2.16078L5.43836 1.48L4.35681 3.16234L5.41577 3.84312L6.49732 2.16078ZM6.60041 1.65562C6.22385 1.77861 5.85683 1.93086 5.5034 2.11052L6.40969 3.89339C6.67149 3.76031 6.94314 3.64766 7.22137 3.55678L6.60041 1.65562ZM6.20105 1.16404L5.93371 2.39377L7.88806 2.81863L8.1554 1.58889L6.20105 1.16404ZM7.64539 0C6.9504 0 6.34869 0.484355 6.20101 1.16419L8.15543 1.58874C8.10322 1.82912 7.89066 2 7.64539 2V0ZM10.3546 0H7.64539V2H10.3546V0ZM11.799 1.16419C11.6513 0.484355 11.0496 0 10.3546 0V2C10.1093 2 9.89678 1.82912 9.84457 1.58874L11.799 1.16419ZM12.0663 2.39377L11.799 1.16404L9.8446 1.58889L10.1119 2.81863L12.0663 2.39377ZM12.4966 2.11052C12.1432 1.93086 11.7761 1.77861 11.3996 1.65562L10.7786 3.55678C11.0569 3.64766 11.3285 3.76031 11.5903 3.89339L12.4966 2.11052ZM12.5616 1.48L11.5027 2.16078L12.5842 3.84312L13.6432 3.16234L12.5616 1.48ZM14.4061 1.67815C13.9145 1.18655 13.1467 1.10408 12.5618 1.47988L13.643 3.16245C13.4366 3.29509 13.1656 3.26608 12.9919 3.09236L14.4061 1.67815ZM16.3219 3.59392L14.4061 1.67815L12.9919 3.09236L14.9076 5.00813L16.3219 3.59392ZM16.5201 5.43818C16.8959 4.85335 16.8134 4.08551 16.3219 3.59392L14.9076 5.00813C14.7339 4.83441 14.7049 4.5634 14.8375 4.35699L16.5201 5.43818ZM15.8392 6.49732L16.52 5.43836L14.8377 4.35681L14.1569 5.41577L15.8392 6.49732ZM16.3444 6.60041C16.2214 6.22385 16.0691 5.85683 15.8895 5.5034L14.1066 6.40969C14.2397 6.67149 14.3523 6.94314 14.4432 7.22137L16.3444 6.60041ZM11 9C11 10.1046 10.1046 11 9 11V13C11.2091 13 13 11.2091 13 9H11ZM9 7C10.1046 7 11 7.89543 11 9H13C13 6.79086 11.2091 5 9 5V7ZM7 9C7 7.89543 7.89543 7 9 7V5C6.79086 5 5 6.79086 5 9H7ZM9 11C7.89543 11 7 10.1046 7 9H5C5 11.2091 6.79086 13 9 13V11Z"
      fill="#8F969F"
    />
  </svg>
);

export const TORSOS_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 8C3.34 8 2 9.34 2 11V12.14V15C2 15.55 1.55 16 1 16C0.45 16 0 15.55 0 15V12.14V11C0 9.28 0.87 7.76 2.2 6.86C1.46 6.13 1 5.12 1 4C1 1.79 2.79 0 5 0C7.06 0 8.75 1.55 8.97 3.55C9.57 3.2 10.26 3 11 3C13.21 3 15 4.79 15 7C15 7.92 14.69 8.77 14.16 9.45C15.26 10.06 16 11.23 16 12.57V15C16 15.55 15.55 16 15 16C14.45 16 14 15.55 14 15V12.57C14 11.7 13.3 11 12.43 11H11H10V12.14V15C10 15.55 9.55 16 9 16C8.45 16 8 15.55 8 15V12.14V11C8 9.34 6.66 8 5 8ZM11 9C12.1 9 13 8.11 13 7C13 5.89 12.1 5 11 5C9.9 5 9 5.89 9 7C9 8.11 9.9 9 11 9ZM5 6C3.9 6 3 5.11 3 4C3 2.89 3.9 2 5 2C6.1 2 7 2.89 7 4C7 5.11 6.1 6 5 6Z"
      fill="#7B828D"
    />
  </svg>
);

export const SEARCH_SVG = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 1.99931C6.23858 1.99931 4 4.23711 4 6.99758C4 9.75806 6.23858 11.9959 9 11.9959C11.7614 11.9959 14 9.75806 14 6.99758C14 4.23711 11.7614 1.99931 9 1.99931ZM2 6.99758C2 3.13293 5.13401 0 9 0C12.866 0 16 3.13293 16 6.99758C16 10.8622 12.866 13.9952 9 13.9952C5.13401 13.9952 2 10.8622 2 6.99758Z"
      fill="#7B828D"
    />
    <rect
      width="6.4922"
      height="1.99965"
      transform="matrix(0.707229 -0.706985 0.707229 0.706985 0 14.5863)"
      fill="#7B828D"
    />
  </svg>
);

export const PLUS_SVG = (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.48528 0V16.9706M0 8.48528H16.9706" stroke="#7B828D" strokeWidth="2" />
  </svg>
);

export const CHECK_CIRCLE = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="22" fill="#1CB394" />
    <path
      d="M-595.262,125.576l-4.125,4.125-7.875,7.875-4.561-4.561"
      transform="translate(625.323 -109.076)"
      fill="#1CB394"
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth="4"
    />
  </svg>
);

export const MINUS_CIRCLE = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="22" fill="#ffaa48" />
    <path
      d="M-707.227,330.758l12,12"
      transform="translate(280.219 -711.466) rotate(-45)"
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth="4"
    />
  </svg>
);

export const TIMES_CIRCLE = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="22" fill="#f85d5d" />
    <g transform="translate(724 -314)">
      <path
        d="M-707.227,330.758l12,12"
        transform="translate(-0.273 -0.258)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="4"
      />
      <path
        d="M-707.227,330.758l12,12"
        transform="translate(-364.742 1037.727) rotate(90)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="4"
      />
    </g>
  </svg>
);

export const DOT_CIRCLE = (
  <svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z"
      fill="#BBBBBB"
    />
    <circle cx="22" cy="22" r="4" fill="white" />
  </svg>
);

export const LOCK_SVG = (
  <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.9681 10.609H16.7902V7.18464C16.7902 3.22303 13.5671 0 9.60553 0C5.64392 0 2.42089 3.22303 2.42089 7.18464V10.609H1.24293C0.556463 10.609 0 11.1655 0 11.8519V22.7569C0 23.4434 0.556463 23.9999 1.24293 23.9999H17.9681C18.6546 23.9999 19.2111 23.4435 19.2111 22.7569V11.852C19.2111 11.1656 18.6546 10.609 17.9681 10.609ZM5.43852 7.18464C5.43852 4.88695 7.30784 3.01763 9.60553 3.01763C11.9032 3.01763 13.7725 4.88695 13.7725 7.18464V10.609H5.43852V7.18464ZM10.9601 17.7179V19.9471C10.9601 20.6952 10.3536 21.3016 9.60553 21.3016C8.85742 21.3016 8.25099 20.6952 8.25099 19.9471V17.7179C7.74714 17.3182 7.42359 16.7011 7.42359 16.0079C7.42359 14.8029 8.40047 13.8259 9.60553 13.8259C10.8106 13.8259 11.7875 14.8029 11.7875 16.0079C11.7875 16.7011 11.4639 17.3183 10.9601 17.7179Z"
      fill="black"
    />
  </svg>
);

export const SUCCESS_SVG = (
  <svg width="80" height="60" viewBox="0 0 55 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.1701 14.5817C47.9885 12.7359 47.9885 9.7434 46.1701 7.89766C44.3516 6.05192 41.4033 6.05192 39.5848 7.89766L21.1226 26.6368L14.5378 19.9532C12.7193 18.1075 9.771 18.1075 7.95253 19.9532C6.13407 21.7989 6.13407 24.7915 7.95253 26.6372L17.8304 36.6633C19.6489 38.509 22.5972 38.509 24.4157 36.6633C24.4334 36.6453 24.451 36.6271 24.4684 36.6089L46.1701 14.5817Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0.0825992"
        y="0.730295"
        width="53.9573"
        height="44.5463"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="0.722892" />
        <feGaussianBlur stdDeviation="3.25301" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.359222 0 0 0 0 0.529888 0 0 0 0 0.641967 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const TROPHY_SVG = (
  <svg width="36" height="48" viewBox="0 0 36 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.2061 45.1875V44.856C30.2061 43.164 29.5713 41.5507 28.4185 40.3133C27.5996 39.4342 26.5731 38.8016 25.4437 38.4657C25.4437 38.4643 25.4436 38.463 25.4436 38.4616L17.5376 37L16.5376 43L17.5376 48H32.6625V45.1875H30.2061Z"
      fill="#FDAE02"
    />
    <path
      d="M9.63155 38.4616C9.63155 38.463 9.63146 38.4643 9.63146 38.4657C8.50215 38.8015 7.47568 39.4342 6.65668 40.3132C5.50393 41.5507 4.86905 43.164 4.86905 44.856V45.1875H2.41261V48H17.5376V37L9.63155 38.4616Z"
      fill="#FDCB02"
    />
    <path
      d="M25.4436 38.4616C25.4332 36.2664 24.5315 34.2163 22.9439 32.7326V26H17.5376L16.5376 30.9999L17.5376 38.4616H25.4436Z"
      fill="#E07037"
    />
    <path
      d="M12.1313 32.7326C10.5436 34.2164 9.64196 36.2664 9.63155 38.4616H17.5376V26H12.1313V32.7326Z"
      fill="#FF9900"
    />
    <path
      d="M17.5376 -7.62939e-06L16.5376 14.0001L17.5376 28.0624C22.2145 28.061 26.6124 26.2402 29.9217 22.9349C33.2323 19.6283 35.0585 15.2305 35.0641 10.5516L35.0768 -7.62939e-06L17.5376 -7.62939e-06Z"
      fill="#FDAE02"
    />
    <path
      d="M0.0253641 0.000579834L5.18929e-05 10.4889C-0.0111981 15.1798 1.80708 19.5922 5.12011 22.9132C8.43315 26.2342 12.8411 28.0631 17.5321 28.0631C17.534 28.0631 17.5358 28.063 17.5376 28.063V0.000579834H0.0253641Z"
      fill="#FDCB02"
    />
    <path
      d="M23.3053 10.42H19.4601L17.5376 7.09013L16.522 13.75L17.5376 20.41L19.4601 17.08H23.3053L21.3828 13.75L23.3053 10.42Z"
      fill="#F7F0EB"
    />
    <path
      d="M15.6151 10.42H11.7699L13.6924 13.75L11.7699 17.08H15.6151L17.5376 20.41V7.09013L15.6151 10.42Z"
      fill="#FAF6F5"
    />
    <path
      d="M25.741 9.01389H20.2721L17.5376 4.27754V4.27764L16.522 8.04695L17.5376 9.90264L18.6482 11.8264H20.8697L19.7589 13.75L20.8697 15.6738H18.6482L17.5376 17.5975L16.522 20.0469L17.5376 23.2225V23.2226L20.2721 18.4863H25.741L23.0065 13.75L25.741 9.01389Z"
      fill="#E07037"
    />
    <path
      d="M16.4269 15.6747H14.2055L15.3162 13.7509L14.2056 11.8273H16.4269L17.5376 9.90353V4.27853L14.8032 9.01478H9.33418L12.0687 13.7509L9.33418 18.4872H14.8032L17.5376 23.2234V17.5984L16.4269 15.6747Z"
      fill="#FF9900"
    />
  </svg>
);

export const BOOK_SVG = (
  <svg width="30" height="30" opacity={0.7} viewBox="0 0 256 256">
    <path
      fill="currentColor"
      d="M108 108a12 12 0 0 1 12-12h56a12 12 0 0 1 0 24h-56a12 12 0 0 1-12-12Zm68 28h-56a12 12 0 0 0 0 24h56a12 12 0 0 0 0-24Zm52-88v160a20.1 20.1 0 0 1-20 20H48a20.1 20.1 0 0 1-20-20V48a20.1 20.1 0 0 1 20-20h160a20.1 20.1 0 0 1 20 20ZM52 204h16V52H52ZM204 52H92v152h112Z"
    />
  </svg>
);
